export default "__VITE_ASSET__BMj8Nw6n__"